<div class="vtr-widget-modern-preload-app app-item">
	<div class="custom-control custom-checkbox pl-0">
		<input type="checkbox"
			class="custom-control-input"
			[tabindex]="!!(modernPreloadService.DownloadButtonStatus === DownloadButtonStatusEnum.DOWNLOADING || appItem.isCheckDisabled) ? -1 : 0"
			[checked]="appItem.isChecked"
			id="modern-preload-app-{{appItem.udcId}}"
			[disabled]="!!(modernPreloadService.DownloadButtonStatus === DownloadButtonStatusEnum.DOWNLOADING || appItem.isCheckDisabled)"
			[attr.aria-label]="appItem.title"
			(keydown.enter)="setAppCheckStatus()"
			(click)="setAppCheckStatus()" />
		<label *ngIf="!(modernPreloadService.DownloadButtonStatus === DownloadButtonStatusEnum.DOWNLOADING || appItem.isCheckDisabled)" 
			class="custom-control-label-out"></label>
		<label class="custom-control-label"
			aria-hidden="true"
			for="modern-preload-app-{{appItem.udcId}}">
			<div class="app-logo">
				<img [src]="appItem.thumbnail" />
			</div>
		</label>
	</div>

	<div class="item-info">
		<b>{{ appItem.title }}</b>
		<div *ngIf="!appItem.isCheckDisabled"
			[ngSwitch]="appItem.showStatus">
			<div class="status-box download_available"
				*ngSwitchCase="this.ModernPreloadStatusEnum.NOT_INSTALL">
				<img class="status-icon"
					[src]="downloadIconBase64 | sanitize : 'resourceUrl'"
					alt=""
					srcset="">
				<div class="status-text"
					role="text"
					id="modern-preload-status-download-available-{{ appItem.udcId }}"
					[innerHTML]="'modernPreload.downloadAvailable' | translate"></div>
			</div>
			<div class="status-box download_complete"
				*ngSwitchCase="this.ModernPreloadStatusEnum.DOWNLOAD_COMPLETE">
				<img class="status-icon"
					[src]="successIconBase64 | sanitize : 'resourceUrl'"
					alt=""
					srcset="">
				<div class="status-text"
					role="text"
					id="modern-preload-status-download-complete-{{ appItem.udcId }}"
					[innerHTML]="'modernPreload.downloadComplete' | translate"></div>
			</div>
			<div class="status-box failed-install"
				*ngSwitchCase="this.ModernPreloadStatusEnum.FAILED_INSTALL">
				<img class="status-icon"
					[src]="errorIconBase64 | sanitize : 'resourceUrl'"
					alt=""
					srcset="">
				<div class="status-text"
					role="text"
					id="modern-preload-status-failed-install-{{ appItem.udcId }}"
					[innerHTML]="'modernPreload.failedInstall' | translate"></div>
			</div>
			<div class="status-box installed"
				*ngSwitchCase="this.ModernPreloadStatusEnum.INSTALLED">
				<img class="status-icon"
					[src]="successIconBase64 | sanitize : 'resourceUrl'"
					alt=""
					srcset="">
				<div class="status-text"
					role="text"
					id="modern-preload-status-installed-{{ appItem.udcId }}"
					[innerHTML]="'modernPreload.installed' | translate"></div>
			</div>
			<div class="status-box downloading"
				*ngSwitchCase="this.ModernPreloadStatusEnum.DOWNLOADING">
				<div class="downloading-text"
					role="text"
					id="modern-preload-status-downloading-{{ appItem.udcId }}">{{ appItem.progress }}% <span [innerHTML]="'modernPreload.downloading' | translate"></span></div>
				<div class="w-100">
					<mat-progress-bar mode="determinate" [value]="appItem.progress">
					</mat-progress-bar> 
				</div>
			</div>
		</div>
		<div *ngIf="appItem.company"
			[dir]="'dir' | translate">{{ appItem.company }}</div>
		<div *ngIf="!appItem.redemptionURL && appItem.size"
			[dir]="'dir' | translate">{{'modernPreload.sizeText' | translate}}: {{ appItem.size }}</div>
		<div *ngIf="!appItem.redemptionURL && appItem.version"
			[dir]="'dir' | translate">{{'modernPreload.versionText' | translate}}: {{ appItem.version }}
		</div>
		<div *ngIf="appItem.activationCode"
			class="redemption-code-content mb-3">
			<div class="text"
				role="text"
				id="modern-preload-redemption-code-title-{{appItem.udcId}}">
				{{'modernPreload.redemptionCode' | translate}}</div>
			<div class="code d-flex align-items-center">
				<div class="redemption-code mr-2 activation-code"
					id="modern-preload-redemption-code-{{appItem.udcId}}"
					role="text"
					*ngIf="appItem.isShowActiveCode">
					{{appItem.activationCode}}</div>
				<div class="redemption-code mr-2 hide-characters d-flex flex-wrap"
					id="modern-preload-redemption-star-{{appItem.udcId}}"
					role="text"
					*ngIf="!appItem.isShowActiveCode"
					[innerHTML]="appItem.hiddenCharacters"></div>
				<div class="redeem-icon"
					(click)="setRedeemStatus()"
					(keydown.enter)="setRedeemStatus()"
					role="button"
					tabindex="0"
					[attr.aria-label]="appItem.isShowActiveCode ? 'hide redemption code' : 'show redemption code'"
					id="modern-preload-button-eye-{{appItem.isShowActiveCode ? 'true' : 'false'}}-{{appItem.udcId}}">
					<fa-icon *ngIf="appItem.isShowActiveCode"
						[icon]="['far', 'eye-slash']"></fa-icon>
					<fa-icon *ngIf="!appItem.isShowActiveCode"
						[icon]="['far', 'eye']"></fa-icon>
				</div>
				<div class="redeem-icon"
					role="button"
					[tabindex]="appItem.isShowActiveCode ? 0 : -1"
					#redeemCodeCopy
					id="modern-preload-button-redeem-code-copy-{{appItem.udcId}}"
					[attr.aria-label]="'copy redemption code'"
					[ngxClipboard]
					(keydown.enter)="copy(appItem.activationCode, 'redeemCodeCopy')"
					[cbContent]="appItem.activationCode">
					<fa-icon *ngIf="appItem.isShowActiveCode"
						[icon]="['fal', 'copy']"></fa-icon>
				</div>
			</div>
		</div>
		<div class="redemption-url d-flex align-items-center"
			*ngIf="appItem.redemptionURL">
			<a class="mr-2"
				href="javascript:void(0)"
				(click)="launchURL()"
				id="modern-preload-button-redeem-url-{{appItem.udcId}}">
				<fa-icon class="pr-1"
					[icon]="['fal', 'external-link']"></fa-icon>
				<span>{{'modernPreload.redeemWebsite' | translate}}</span>
			</a>
			<div class="redeem-icon"
				role="button"
				tabindex="0"
				#redeemUrlCopy
				id="modern-preload-button-redeem-url-copy-{{appItem.udcId}}"
				[attr.aria-label]="'copy redemption link'"
				[ngxClipboard]
				(keydown.enter)="copy(appItem.redemptionURL, 'redeemUrlCopy')"
				[cbContent]="appItem.redemptionURL">
				<fa-icon [icon]="['fal', 'copy']"></fa-icon>
			</div>
			<div class="redeem-icon"></div>
		</div>
	</div>
</div>